<div class="popup-content">
  <div class="popup-title">{{lilate.student.user.first_name}} {{lilate.student.user.last_name}}'s ID</div>
  <div class="id-wrapper">
    <div class="id-pic">
        <img src="{{lilate.student.user.photo_profile.photo_identity}}" alt="identity_picture">
    </div>
    <div class="id-document">
        <img [src]="identityCard" alt="identity_card">
    </div>
  </div>
  <div class="id-actions-wrap">
    <div class="id-actions-subwrap" *ngIf="!report">
        <button class="close-btn" (click)="closeModal()" translate>lilate.identity-check.closeButton</button>
        <button class="problem-btn" (click)="report = true" translate>lilate.identity-check.reportButton</button>
    </div>
    <div class="report-issue-wrap" *ngIf="report">
        <select style="display: block;" [(ngModel)]="issue">
            <div class="report-issue-title" translate>lilate.identity-check.reportIssueTitle</div>
            <option [value]="'identity_issue'" translate>lilate.identity-check.issueOption1</option>
            <option [value]="'abs_student_without_justification'" translate>lilate.identity-check.issueOption2</option>
        </select>
        <div class="actions-wrapper">
          <button (click)="closeModal()" class="cancel-issue-btn" translate>lilate.identity-check.cancelButton</button>
          <button class="report-issue-btn" *ngIf="report" (click)="reportIssueLilate()" translate>lilate.identity-check.submitReportButton</button>
        </div>
    </div>
</div>